/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Search_ErrorInputs */

const vi_map_search_error = /** @type {(inputs: Map_Search_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm được địa điểm do lỗi kết nối Google Maps, hãy thử lại`)
};

/**

* @param {Map_Search_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const map_search_error = /** @type {((inputs?: Map_Search_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Search_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_map_search_error(inputs)
});